import { FC } from 'react';
import { UserRow } from '../types';
import ListCell, { ListCellProps } from './ListCell';
import { usePopover } from '../../../context/PopoverProvider';
import TokensAdditionalInfo from '../../TokensAdditionalInfo';
import { EntityChip } from '@silverfort/sf-components';
import { TOKEN_TYPE_TO_DETAILS } from '../../../consts';
import { DeviceToken } from '../../../types/User';
import { useUserDrawer } from '../../../hooks/useUserDrawer';

type Props = UserRow;

const TokensCell: FC<Props> = ({ id: userId, tokens }) => {
    const { openPopover, closePopover } = usePopover();
    const { openUserDrawer } = useUserDrawer();

    const handleViewTokenClick = (tokenId: DeviceToken['id']) => {
        openUserDrawer(userId, tokenId);
        closePopover();
    };

    const handleViewAllTokensClick = () => {
        openUserDrawer(userId);
        closePopover();
    };

    const handleMoreClick: ListCellProps['onMoreClick'] = (element) => {
        openPopover({
            Content: (
                <TokensAdditionalInfo
                    tokens={tokens}
                    onViewTokenClick={handleViewTokenClick}
                    onViewAllTokensClick={handleViewAllTokensClick}
                />
            ),
            anchorEl: element
        });
    };

    return (
        <ListCell maxChildrenToDisplay={2} onMoreClick={handleMoreClick}>
            {tokens.map((token) => {
                const { icon, iconClassName } = TOKEN_TYPE_TO_DETAILS[token.type];
                return <EntityChip key={token.id} icon={icon} iconClassName={iconClassName} />;
            })}
        </ListCell>
    );
};

export default TokensCell;
